import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-pagamento-inteligente',
  template: `
  <router-outlet></router-outlet>
`,
})
export class PagamentoInteligenteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
